import { render } from "./MessageSharingPopUp.vue?vue&type=template&id=83a9635c&scoped=true&ts=true"
import script from "./MessageSharingPopUp.vue?vue&type=script&lang=ts"
export * from "./MessageSharingPopUp.vue?vue&type=script&lang=ts"

import "./MessageSharingPopUp.vue?vue&type=style&index=0&id=83a9635c&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a9635c"]])

export default __exports__